import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { useTipos } from "../../../../context/SuperAdmin/OASContexts/TiposContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { TiposRow } from "./TiposRow";

const TiposTable = () => {
  const { tipos, setSelectedTipos, selectedTipos, searchText } = useTipos();

  const selectAll = () => {
    setSelectedTipos(filteredTipos.map((tipo) => tipo.id_tipo));
  };

  // Manejar selección/deselección de un tipo
  const handleSelect = (id: string) => {
    setSelectedTipos((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Filtro de tipos por búsqueda
  const filteredTipos = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return tipos.filter((u) =>
      u.nombre.toLowerCase().includes(normalizedSearch)
    );
  }, [tipos, searchText]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedTipos.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedTipos([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de creación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Acciones
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredTipos.length > 0 ? (
            filteredTipos.map((item, index) => (
              <TiposRow
                tipo={item}
                i={index + 1}
                key={item.id_tipo}
                handleSelect={handleSelect}
                isSelected={selectedTipos.includes(item.id_tipo)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TiposTable;
